export default {
  ['search'](state, payload) {
    state.total = payload.total;
    state.pages = payload.pages;
    state.page = payload.page;
    state.limit = payload.limit;
    state.sortBy = payload.sortBy;
    state.sortDesc = payload.sortDesc;
    state.conditions = payload.conditions;
    state.list = payload.list;
  },

  ['loadForm'](state, payload) {
    state.form.id = payload.id;
    state.form.company = payload.company;
    state.form.name = payload.name;
    state.form.email = payload.email;
    state.form.comment = payload.comment;
  },

  ['clearForm'](state, payload) {
    state.form.id = null;
    state.form.company = '';
    state.form.name = '';
    state.form.email = '';
    state.form.comment = '';
  },
};
